import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { constants } from '../constants/constants';

@Pipe({
  name: 'sentenceCase'
})
export class SentenceCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    value = value.trim().toLowerCase();
    return value.replace(constants.sentenceCaseRegex, (char) => char.toUpperCase());
  }
}